import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './ButtonGroup.scss';
/**
 * @component ButtonGroup
 * @since 1.0.0
 */
export function ButtonGroup(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const children = React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return React.createElement("div", { className: "button-group-item" }, child);
        }
        return child;
    });
    const className = classNames('button-group', 'button-group--' + style, props.className);
    return React.createElement("div", { className: className }, children);
}
